import axios from 'axios';
import router from '../router/routes';
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_AXIOS_BASE_URL;
axios.defaults.headers.post['Accept'] = 'application/json';

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401 || error.response.status === 403) {
            document.cookie = "XSRF-TOKEN=; Domain=.swyft.local; Path=/; Expires=Mon, 06 Oct 1975 00:00:01 GMT;";

            if (router.currentRoute.name !== 'Login') {
                router.push({name: 'Login'});
            }
        }
        return Promise.reject(error);
    });
